export const tabOptions = ["All Packages", "Unassigned", "Assigned", "In-Transit","Delivered","Expired"];
export const tableHeadersAll= [ "Package Name", "Origin", "Destination ", "Sender Name", "Weight (lbs)", "Expiry Date", "Status"]
export const tableHeadersAction= [ "Package Name", "Origin", "Destination ", "Sender Name", "Weight (lbs)", "Expiry Date", "Action"]
export const filterByRadius = ["All", "50", "100", "150", "200", "250"];
export const deliveryTabOptions = ["Assigned", "In-Transit","Delivered"];
export const mobUserDeliveryTabOptions = ["Unassigned", "Assigned", "In-Transit","Delivered"];
export const sortByList = [{
  id: '1',
  value: "Expiry Date"
},
{
  id: '2',
  value: "Origin"
},
{
  id: '3',
  value: "Destination"
}]
export const sortByUserList = [{
  id: '0',
  value: "All"
},
{
  id: '1',
  value: "Requester"
},
{
  id: '2',
  value: "Delivery Person"
}]
export const dummyData = [ 
{
    "packageId": 7594,
    "packagePin": 869262,
    "title": "GF Package 4",
    "weight": 22,
    "sourceCity": "Sand Coulee",
    "destinationCity": "Black Eagle",
    "expiryDate": "2024-11-30T00:00:00",
    "sourceLatitude": 47.39896,
    "sourceLongitude": -111.1676241,
    "destinationLatitude": 47.5246802,
    "destinationLongitude": -111.2783075,
    "status": 1
  },
  {
    "packageId": 7615,
    "packagePin": 443965,
    "title": "Lewistown 013",
    "weight": 65.81,
    "sourceCity": "Moore",
    "destinationCity": "Harlowton",
    "expiryDate": "2024-11-28T00:00:00",
    "sourceLatitude": 46.9766331,
    "sourceLongitude": -109.6936785,
    "destinationLatitude": 46.4377123,
    "destinationLongitude": -109.8373988,
    "status": 1
  },

  {
    "packageId": 1046,
    "packagePin": 491202,
    "title": "new package 9",
    "weight": 12.88,
    "sourceCity": "#_-/;&.,",
    "destinationCity": "#_-/;&.,",
    "expiryDate": "2024-10-09T00:00:00",
    "sourceLatitude": 46.5233831,
    "sourceLongitude": -112.184223,
    "destinationLatitude": 45.6916438,
    "destinationLongitude": -111.0464164,
    "status": 2
  },
  {
    "packageId": 1029,
    "packagePin": 371143,
    "title": "hshshshh",
    "weight": 9,
    "sourceCity": "anakapalli",
    "destinationCity": "mirzapur",
    "expiryDate": "2024-10-31T00:00:00",
    "sourceLatitude": 17.6896435,
    "sourceLongitude": 83.0023634,
    "destinationLatitude": 29.1923833,
    "destinationLongitude": 75.8156257,
    "status":3
},
{
    "packageId": 1007,
    "packagePin": 887173,
    "title": "personal",
    "weight": 10,
    "sourceCity": "chennai",
    "destinationCity": "chennai",
    "expiryDate": "2024-08-14T00:00:00",
    "sourceLatitude": 13.0843007,
    "sourceLongitude": 80.2704622,
    "destinationLatitude": 13.0843007,
    "destinationLongitude": 80.2704622,
    "status":4
  },
  {
    "packageId": 1049,
    "packagePin": 224370,
    "title": "hwhehheh",
    "weight": 6,
    "sourceCity": "chittoor",
    "destinationCity": "tirupathi",
    "expiryDate": "2024-08-22T00:00:00",
    "sourceLatitude": 13.4787911,
    "sourceLongitude": 78.8382644,
    "destinationLatitude": 13.6287557,
    "destinationLongitude": 79.4191795,
    "status":5
  }
]

export const statusHolder=[
  ["#FF30F1","#FCE8FF","All Package"],
  ["#FF30F1","#FCE8FF","Unassigned"],
  ["#4E42FF","#EAEAFF","Assigned"],
  ["#FF9500","#FFF5E1","In-transit"],
  ["#027A48","#ECFDF3","Delivered"],
  ["#FF3B30","#FFD7D4","Expired"],
]

export const statusMapping = {
  1: "Unassigned",
  2: "Assigned",
  3: "Intransit",
  4: "Delivered",
};

export const initialMapping = {
  1: "Unassigned",
  2: "Assigned",
};

export const secondMapping = {
  1: "Unassigned",
  2: "Assigned",
  3: "Intransit",
};

export const thirdMapping = {
  3: "Intransit",
  6: "Intransit",
};

export const mapHeight = {
  Unassigned: "670px",
  Assigned: "980px",
  Intransit: "980px",
  Delivered: "1000px",
};
